import { FC, PropsWithChildren, ReactNode } from 'react';

import { usePermission } from '../hooks';
import { Permission } from '../lib';

interface ProtectedContentProps extends PropsWithChildren {
	fallback?: ReactNode;
	permissions?: Permission[] | Permission;
}

export const ProtectedContent: FC<ProtectedContentProps> = ({ children, fallback, permissions }) => {
	const isAllowed = usePermission(permissions);

	if (!isAllowed) return fallback || null;
	return children;
};
